import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { VolumeOfEmployment } from '../../../../shared/interfaces';
import { AppSettings } from '../../../../shared/models';
import { AbstractBasicDataApiService } from '../../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class VolumeOfEmploymentApiService extends AbstractBasicDataApiService<VolumeOfEmployment> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.basicinformation.employees.volumeofemployment);
  }
}
